export default __webpack_public_path__ + "static/media/estate.dc5cb939.jpg";